document.addEventListener('DOMContentLoaded', ()=>{
  let h = document.querySelector('h1.js-colorAdder');
  const h1_arr = h.innerHTML.split(' ');
  console.log(h1_arr.length)
  if (h1_arr.length <= 1 ){
    h.innerHTML = `<span class="gold-color">${h1_arr[0]}</span>`;
  } else if(h1_arr.length == 2 ){
      h.innerHTML = `<span class="gold-color">${h1_arr[0]}</span> ${h1_arr[1]}`;
  } else {
      h.innerHTML = `<span class="gold-color">${h1_arr[0]}</span> ${h1_arr[1]} ${h1_arr[2]}`
  }
})